export default __webpack_public_path__ + "static/media/whiteWarning.6f25de35.svg";